<template>
  <SidebarLayout disable-sidebar-margin-right>
    <template #nav>
      <ReportsNav />
    </template>
    <template #body>
      <slot />
    </template>
  </SidebarLayout>
</template>

<script>
import ReportsNav from '@/components/nav/ReportsNav.vue';
import SidebarLayout from '@/layouts/SidebarLayout';

export default {
  name: 'ReportsLayout',

  components: {
    ReportsNav,
    SidebarLayout,
  },
};
</script>
